import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AuthService } from "src/app/services/auth/auth.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { UserService } from "src/app/services/user/user.service";
import firebase from "firebase/app";
import { StorageService } from "src/app/services/storage/storage.service";
import { RouterService } from "src/app/services/router/router.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { environment } from "src/environments/environment";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";
import { ChangePhoneOtpPage } from "../change-phone-otp/change-phone-otp.page";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-change-phone",
  templateUrl: "./change-phone.page.html",
  styleUrls: ["./change-phone.page.scss"],
})

export class ChangePhonePage implements OnInit {
  changePhoneForm: FormGroup;
  messageError: Promise<string>;
  userFirebase: firebase.User;
  emailActual = "";
  phoneIndicators;
  phoneIndicator = {
    'indicator': environment.phoneIndicator,
    'country': environment.country,
    'code': environment.country,
  };

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public languageService: LanguagesService,
    public userService: UserService,
    private routerService: RouterService,
    private storageService: StorageService,
    private alertService: AlertService,
    private remoteConfig: RemoteConfigService,
    private modalController: ModalController
  ) { }

  async initConstructor() {
    this.changePhoneForm = this.formBuilder.group({
      phone: [
        "",
        Validators.compose([Validators.required, Validators.minLength(10)]),
      ],
    });
    this.userFirebase = await this.authService.getUSerInfoFromFirebase();
  }
  async ngOnInit() {
    this.initConstructor();
    var indicatorStorage = await this.storageService.get('phoneIndicators');
    if (indicatorStorage && indicatorStorage.length > 0) {
      this.phoneIndicators = indicatorStorage;
    } else {
      this.remoteConfig.getInfoApp().subscribe((data: any) => {
        if (data['phone-indicators']) {
          this.phoneIndicators = data['phone-indicators'];
          this.storageService.set('phoneIndicators', this.phoneIndicators);
        }
      });
    }
  }
  async changePhone() {
    const userFirebase = await this.authService.getUSerInfoFromFirebase();
    let { phone } = this.changePhoneForm.value;
    let parsePhone = phone.toString().replace(/ /g, "");
    const completePhone = this.phoneIndicator['indicator'] + phone;

    if (userFirebase.phoneNumber == phone) {
      this.alertService.presentAlert("Porfavor ingrese un número diferente al actual");
      return;
    }
    await this.storageService.set("phone-to-change", completePhone);
    this.modalController.dismiss(null, null, "changePhone")
    this.routerService.redirect("change-phone-otp", ChangePhoneOtpPage, null, "gnx-modal-absolute", null, "changePhoneOtp");
  }

  indicatorSelect(event) {
    const data = event.target.value;
    this.changePhoneForm.controls['phone'].setValidators([Validators.minLength(data.minLength), Validators.maxLength(data.maxLength)]);
    this.phoneIndicator = data
  }

  getValidations(name, nameField) {
    const container = document.getElementById('phoneErrors');
    let form = this.changePhoneForm.get(name);
    container.innerHTML = '';
    let htmlError = '';

    //Validaciones
    if (form?.hasError('required')) {
      htmlError += `<p>${nameField} requerido.</p> `;
    }
    if (form?.hasError('minlength')) {
      htmlError += `<p>${nameField} debe tener mínimo ${form?.errors.minlength.requiredLength} carácteres.</p> `;
    }
    if (form?.hasError('maxlength')) {
      htmlError += `<p>${nameField} debe tener máximo ${form?.errors.maxlength.requiredLength} carácteres.</p> `;
    }

    if (form?.hasError('pattern')) {
      if (name == 'phone') {
        htmlError += `<p>${nameField} de tener solo números</p>`;
      }
    }
    container.insertAdjacentHTML('afterbegin', htmlError);

  }

  get getInputError() {
    return this.languageService.textsIU.input_error;
  }
  get getTextIUPageEmail() {
    return this.languageService.textsIU.page_change_email;
  }
}